// Helper para obtener código de región por país
export const obtenerCodigoRegionPorPais = (nombrePais) => {
  if (!nombrePais) return "+000";
  
  // Normalizar nombre del país para búsqueda case-insensitive
  const nombreNormalizado = String(nombrePais).trim().toLowerCase();
  
  const codigos = {
    "bolivia": "+591",
    "argentina": "+54", 
    "peru": "+51",
    "perú": "+51",
    "brasil": "+55",
    "chile": "+56",
    "paraguay": "+595",
    "uruguay": "+598",
    "méxico": "+52",
    "mexico": "+52",
    "colombia": "+57",
    "ecuador": "+593",
    "españa": "+34",
    "espana": "+34",
    "estados unidos": "+1",
    "venezuela": "+58"
  };

  return codigos[nombreNormalizado] || "+000";
};

// Función para obtener código de región desde los datos del estudiante (síncrona con cache opcional)
// Si necesita buscar el país, puede retornar una Promise
export const obtenerCodigoRegion = (persona, departamento, paisesCache = null) => {
  // Si ya tiene código de región válido, lo devuelve
  if (persona?.CodigoRegion && persona.CodigoRegion !== "+000" && persona.CodigoRegion !== "N/A") {
    return persona.CodigoRegion;
  }

  // Si el departamento tiene idPais y tenemos cache de países, buscar síncrono
  if (departamento?.idPais && paisesCache) {
    const paisEncontrado = paisesCache.find(p => p.idPais === departamento.idPais);
    if (paisEncontrado?.nombre) {
      const codigo = obtenerCodigoRegionPorPais(paisEncontrado.nombre);
      if (codigo !== "+000") {
        return codigo;
      }
    }
  }

  // Si el departamento tiene idPais pero no hay cache, retornar Promise para búsqueda async
  if (departamento?.idPais && !paisesCache) {
    return (async () => {
      try {
        const { getAllPaises } = await import("../services/pais.service");
        const paises = await getAllPaises();
        const paisEncontrado = paises?.find(p => p.idPais === departamento.idPais);
        if (paisEncontrado?.nombre) {
          const codigo = obtenerCodigoRegionPorPais(paisEncontrado.nombre);
          if (codigo !== "+000") {
            return codigo;
          }
        }
      } catch (error) {
        console.warn('Error obteniendo país para código de región:', error);
      }
      // Si falla, seguir con el fallback
      return obtenerCodigoRegionPorDepartamento(departamento);
    })();
  }

  // Fallback: intentar calcularlo por el nombre del departamento
  return obtenerCodigoRegionPorDepartamento(departamento);
};

// Función auxiliar para obtener código de región por nombre de departamento (síncrona)
const obtenerCodigoRegionPorDepartamento = (departamento) => {
  if (!departamento?.nombre) {
    return "N/A";
  }
  
  const nombreDepartamento = departamento.nombre.toLowerCase();
  
  // Mapeo de departamentos bolivianos
  if (nombreDepartamento.includes('la paz') || 
      nombreDepartamento.includes('cochabamba') || 
      nombreDepartamento.includes('santa cruz') ||
      nombreDepartamento.includes('oruro') ||
      nombreDepartamento.includes('potosí') ||
      nombreDepartamento.includes('potosi') ||
      nombreDepartamento.includes('chuquisaca') ||
      nombreDepartamento.includes('tarija') ||
      nombreDepartamento.includes('beni') ||
      nombreDepartamento.includes('pando')) {
    return "+591";
  }
  
  // Mapeo de departamentos peruanos (más completo)
  if (nombreDepartamento.includes('lima') || 
      nombreDepartamento.includes('arequipa') || 
      nombreDepartamento.includes('cusco') ||
      nombreDepartamento.includes('cuzco') ||
      nombreDepartamento.includes('piura') ||
      nombreDepartamento.includes('trujillo') ||
      nombreDepartamento.includes('chiclayo') ||
      nombreDepartamento.includes('huancayo') ||
      nombreDepartamento.includes('tacna') ||
      nombreDepartamento.includes('iquitos') ||
      nombreDepartamento.includes('pucallpa') ||
      nombreDepartamento.includes('ucayali') ||
      nombreDepartamento.includes('tumbes') ||
      nombreDepartamento.includes('san martín') ||
      nombreDepartamento.includes('san martin') ||
      nombreDepartamento.includes('moquegua') ||
      nombreDepartamento.includes('madre de dios') ||
      nombreDepartamento.includes('loreto') ||
      nombreDepartamento.includes('lambayeque') ||
      nombreDepartamento.includes('junín') ||
      nombreDepartamento.includes('junin') ||
      nombreDepartamento.includes('ica') ||
      nombreDepartamento.includes('huánuco') ||
      nombreDepartamento.includes('huanuco') ||
      nombreDepartamento.includes('huancavelica') ||
      nombreDepartamento.includes('cajamarca') ||
      nombreDepartamento.includes('ayacucho') ||
      nombreDepartamento.includes('apurímac') ||
      nombreDepartamento.includes('apurimac') ||
      nombreDepartamento.includes('ancash') ||
      nombreDepartamento.includes('amazonas') ||
      nombreDepartamento.includes('la libertad')) {
    return "+51";
  }
  
  // Mapeo de departamentos argentinos
  if (nombreDepartamento.includes('buenos aires') || 
      nombreDepartamento.includes('córdoba') || 
      nombreDepartamento.includes('cordoba') ||
      nombreDepartamento.includes('rosario') ||
      nombreDepartamento.includes('mendoza') ||
      nombreDepartamento.includes('tucumán') ||
      nombreDepartamento.includes('tucuman') ||
      nombreDepartamento.includes('salta') ||
      nombreDepartamento.includes('santa fe')) {
    return "+54";
  }
  
  // Mapeo de departamentos mexicanos
  if (nombreDepartamento.includes('méxico') ||
      nombreDepartamento.includes('mexico') ||
      nombreDepartamento.includes('jalisco') ||
      nombreDepartamento.includes('puebla') ||
      nombreDepartamento.includes('veracruz') ||
      nombreDepartamento.includes('yucatán') ||
      nombreDepartamento.includes('yucatan')) {
    return "+52";
  }

  return "N/A";
};
